/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { ListPayoutsResponse } from '../models';
// @ts-ignore
import type { PayoutDetailResponse } from '../models';
/**
 * PayoutReportingApi - axios parameter creator
 * @export
 */
export const PayoutReportingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Exports a single merchant\'s payout detail for a specific settlement date as a PDF document.  **File Format:** - Filename format: `payout_detail_{merchantId}_{activityDate}.pdf` - Example: `payout_detail_01HQWX_2026-02-24.pdf` 
         * @summary Export payout detail as PDF
         * @param {string} partnerId Partner identifier
         * @param {string} merchantId Merchant identifier
         * @param {string} activityDate Settlement activity date (ISO 8601 YYYY-MM-DD)
         * @param {ExportPayoutDetailFormatEnum} format Export format: - pdf: PDF document (application/pdf) 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPayoutDetail: async (partnerId: string, merchantId: string, activityDate: string, format: ExportPayoutDetailFormatEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('exportPayoutDetail', 'partnerId', partnerId)
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('exportPayoutDetail', 'merchantId', merchantId)
            // verify required parameter 'activityDate' is not null or undefined
            assertParamExists('exportPayoutDetail', 'activityDate', activityDate)
            // verify required parameter 'format' is not null or undefined
            assertParamExists('exportPayoutDetail', 'format', format)
            const localVarPath = `/api/v1/payment-reporting/partners/{partnerId}/payouts/{merchantId}/{activityDate}/export`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"activityDate"}}`, encodeURIComponent(String(activityDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exports payout summary data in the specified format (CSV or XLSX). Uses the same filtering as the payout list endpoint.  **Export Limits:** - Maximum 10,000 rows per export request  **File Format:** - Filename format: `payouts_{startDate}_to_{endDate}.{format}` - Example: `payouts_2026-02-01_to_2026-02-28.csv` 
         * @summary Export payout summaries as CSV or Excel
         * @param {string} partnerId Partner identifier
         * @param {ExportPayoutsFormatEnum} format Export format: - csv: Comma-separated values (text/csv) - xlsx: Excel spreadsheet (application/vnd.openxmlformats-officedocument.spreadsheetml.sheet) 
         * @param {string} startDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} endDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated merchant IDs to filter by
         * @param {string} [merchantName] Partial match on merchant name (case-insensitive, minimum 2 characters)
         * @param {number} [minAmount] Minimum net payout amount in cents (inclusive). Must be less than or equal to maxAmount if both are provided. 
         * @param {number} [maxAmount] Maximum net payout amount in cents (inclusive). Must be greater than or equal to minAmount if both are provided. 
         * @param {ExportPayoutsSortByEnum} [sortBy] Field to sort by
         * @param {ExportPayoutsSortDirectionEnum} [sortDirection] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPayouts: async (partnerId: string, format: ExportPayoutsFormatEnum, startDate: string, endDate: string, merchantIds?: string, merchantName?: string, minAmount?: number, maxAmount?: number, sortBy?: ExportPayoutsSortByEnum, sortDirection?: ExportPayoutsSortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('exportPayouts', 'partnerId', partnerId)
            // verify required parameter 'format' is not null or undefined
            assertParamExists('exportPayouts', 'format', format)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('exportPayouts', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('exportPayouts', 'endDate', endDate)
            const localVarPath = `/api/v1/payment-reporting/partners/{partnerId}/payouts/export`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (merchantIds !== undefined) {
                localVarQueryParameter['merchantIds'] = merchantIds;
            }

            if (merchantName !== undefined) {
                localVarQueryParameter['merchantName'] = merchantName;
            }

            if (minAmount !== undefined) {
                localVarQueryParameter['minAmount'] = minAmount;
            }

            if (maxAmount !== undefined) {
                localVarQueryParameter['maxAmount'] = maxAmount;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a full financial breakdown for a specific merchant\'s payout on a given settlement date, including gross revenue, refunds, chargebacks, fee breakdown, and individual refund/chargeback transactions.  **Net Payout Formula:** `grossRevenue - fullRefunds - partialRefunds - serviceFees - platformFees - chargebackFees - chargebacks` 
         * @summary Get detailed payout breakdown for a merchant on a specific date
         * @param {string} partnerId Partner identifier
         * @param {string} merchantId Merchant identifier
         * @param {string} activityDate Settlement activity date (ISO 8601 YYYY-MM-DD)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutDetail: async (partnerId: string, merchantId: string, activityDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getPayoutDetail', 'partnerId', partnerId)
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getPayoutDetail', 'merchantId', merchantId)
            // verify required parameter 'activityDate' is not null or undefined
            assertParamExists('getPayoutDetail', 'activityDate', activityDate)
            const localVarPath = `/api/v1/payment-reporting/partners/{partnerId}/payouts/{merchantId}/{activityDate}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"activityDate"}}`, encodeURIComponent(String(activityDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated payout summaries grouped by merchant and settlement date. Each row represents one merchant\'s settled activity for one day.  **Date Range:** Maximum 90 days. End date cannot be in the future. 
         * @summary List payout summaries by merchant and settlement date
         * @param {string} partnerId Partner identifier
         * @param {string} startDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} endDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {string} [merchantIds] Comma-separated merchant IDs to filter by
         * @param {string} [merchantName] Partial match on merchant name (case-insensitive, minimum 2 characters)
         * @param {ListPayoutsSortByEnum} [sortBy] Field to sort by
         * @param {ListPayoutsSortDirectionEnum} [sortDirection] Sort direction
         * @param {number} [minAmount] Minimum net payout amount in cents (inclusive). Must be less than or equal to maxAmount if both are provided. 
         * @param {number} [maxAmount] Maximum net payout amount in cents (inclusive). Must be greater than or equal to minAmount if both are provided. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPayouts: async (partnerId: string, startDate: string, endDate: string, page?: number, size?: number, merchantIds?: string, merchantName?: string, sortBy?: ListPayoutsSortByEnum, sortDirection?: ListPayoutsSortDirectionEnum, minAmount?: number, maxAmount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('listPayouts', 'partnerId', partnerId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('listPayouts', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('listPayouts', 'endDate', endDate)
            const localVarPath = `/api/v1/payment-reporting/partners/{partnerId}/payouts`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (merchantIds !== undefined) {
                localVarQueryParameter['merchantIds'] = merchantIds;
            }

            if (merchantName !== undefined) {
                localVarQueryParameter['merchantName'] = merchantName;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (minAmount !== undefined) {
                localVarQueryParameter['minAmount'] = minAmount;
            }

            if (maxAmount !== undefined) {
                localVarQueryParameter['maxAmount'] = maxAmount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PayoutReportingApi - functional programming interface
 * @export
 */
export const PayoutReportingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PayoutReportingApiAxiosParamCreator(configuration)
    return {
        /**
         * Exports a single merchant\'s payout detail for a specific settlement date as a PDF document.  **File Format:** - Filename format: `payout_detail_{merchantId}_{activityDate}.pdf` - Example: `payout_detail_01HQWX_2026-02-24.pdf` 
         * @summary Export payout detail as PDF
         * @param {string} partnerId Partner identifier
         * @param {string} merchantId Merchant identifier
         * @param {string} activityDate Settlement activity date (ISO 8601 YYYY-MM-DD)
         * @param {ExportPayoutDetailFormatEnum} format Export format: - pdf: PDF document (application/pdf) 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPayoutDetail(partnerId: string, merchantId: string, activityDate: string, format: ExportPayoutDetailFormatEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPayoutDetail(partnerId, merchantId, activityDate, format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayoutReportingApi.exportPayoutDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exports payout summary data in the specified format (CSV or XLSX). Uses the same filtering as the payout list endpoint.  **Export Limits:** - Maximum 10,000 rows per export request  **File Format:** - Filename format: `payouts_{startDate}_to_{endDate}.{format}` - Example: `payouts_2026-02-01_to_2026-02-28.csv` 
         * @summary Export payout summaries as CSV or Excel
         * @param {string} partnerId Partner identifier
         * @param {ExportPayoutsFormatEnum} format Export format: - csv: Comma-separated values (text/csv) - xlsx: Excel spreadsheet (application/vnd.openxmlformats-officedocument.spreadsheetml.sheet) 
         * @param {string} startDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} endDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated merchant IDs to filter by
         * @param {string} [merchantName] Partial match on merchant name (case-insensitive, minimum 2 characters)
         * @param {number} [minAmount] Minimum net payout amount in cents (inclusive). Must be less than or equal to maxAmount if both are provided. 
         * @param {number} [maxAmount] Maximum net payout amount in cents (inclusive). Must be greater than or equal to minAmount if both are provided. 
         * @param {ExportPayoutsSortByEnum} [sortBy] Field to sort by
         * @param {ExportPayoutsSortDirectionEnum} [sortDirection] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPayouts(partnerId: string, format: ExportPayoutsFormatEnum, startDate: string, endDate: string, merchantIds?: string, merchantName?: string, minAmount?: number, maxAmount?: number, sortBy?: ExportPayoutsSortByEnum, sortDirection?: ExportPayoutsSortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPayouts(partnerId, format, startDate, endDate, merchantIds, merchantName, minAmount, maxAmount, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayoutReportingApi.exportPayouts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a full financial breakdown for a specific merchant\'s payout on a given settlement date, including gross revenue, refunds, chargebacks, fee breakdown, and individual refund/chargeback transactions.  **Net Payout Formula:** `grossRevenue - fullRefunds - partialRefunds - serviceFees - platformFees - chargebackFees - chargebacks` 
         * @summary Get detailed payout breakdown for a merchant on a specific date
         * @param {string} partnerId Partner identifier
         * @param {string} merchantId Merchant identifier
         * @param {string} activityDate Settlement activity date (ISO 8601 YYYY-MM-DD)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayoutDetail(partnerId: string, merchantId: string, activityDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayoutDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayoutDetail(partnerId, merchantId, activityDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayoutReportingApi.getPayoutDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated payout summaries grouped by merchant and settlement date. Each row represents one merchant\'s settled activity for one day.  **Date Range:** Maximum 90 days. End date cannot be in the future. 
         * @summary List payout summaries by merchant and settlement date
         * @param {string} partnerId Partner identifier
         * @param {string} startDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} endDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {string} [merchantIds] Comma-separated merchant IDs to filter by
         * @param {string} [merchantName] Partial match on merchant name (case-insensitive, minimum 2 characters)
         * @param {ListPayoutsSortByEnum} [sortBy] Field to sort by
         * @param {ListPayoutsSortDirectionEnum} [sortDirection] Sort direction
         * @param {number} [minAmount] Minimum net payout amount in cents (inclusive). Must be less than or equal to maxAmount if both are provided. 
         * @param {number} [maxAmount] Maximum net payout amount in cents (inclusive). Must be greater than or equal to minAmount if both are provided. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPayouts(partnerId: string, startDate: string, endDate: string, page?: number, size?: number, merchantIds?: string, merchantName?: string, sortBy?: ListPayoutsSortByEnum, sortDirection?: ListPayoutsSortDirectionEnum, minAmount?: number, maxAmount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPayoutsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPayouts(partnerId, startDate, endDate, page, size, merchantIds, merchantName, sortBy, sortDirection, minAmount, maxAmount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayoutReportingApi.listPayouts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PayoutReportingApi - factory interface
 * @export
 */
export const PayoutReportingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PayoutReportingApiFp(configuration)
    return {
        /**
         * Exports a single merchant\'s payout detail for a specific settlement date as a PDF document.  **File Format:** - Filename format: `payout_detail_{merchantId}_{activityDate}.pdf` - Example: `payout_detail_01HQWX_2026-02-24.pdf` 
         * @summary Export payout detail as PDF
         * @param {string} partnerId Partner identifier
         * @param {string} merchantId Merchant identifier
         * @param {string} activityDate Settlement activity date (ISO 8601 YYYY-MM-DD)
         * @param {ExportPayoutDetailFormatEnum} format Export format: - pdf: PDF document (application/pdf) 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPayoutDetail(partnerId: string, merchantId: string, activityDate: string, format: ExportPayoutDetailFormatEnum, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportPayoutDetail(partnerId, merchantId, activityDate, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Exports payout summary data in the specified format (CSV or XLSX). Uses the same filtering as the payout list endpoint.  **Export Limits:** - Maximum 10,000 rows per export request  **File Format:** - Filename format: `payouts_{startDate}_to_{endDate}.{format}` - Example: `payouts_2026-02-01_to_2026-02-28.csv` 
         * @summary Export payout summaries as CSV or Excel
         * @param {string} partnerId Partner identifier
         * @param {ExportPayoutsFormatEnum} format Export format: - csv: Comma-separated values (text/csv) - xlsx: Excel spreadsheet (application/vnd.openxmlformats-officedocument.spreadsheetml.sheet) 
         * @param {string} startDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} endDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} [merchantIds] Comma-separated merchant IDs to filter by
         * @param {string} [merchantName] Partial match on merchant name (case-insensitive, minimum 2 characters)
         * @param {number} [minAmount] Minimum net payout amount in cents (inclusive). Must be less than or equal to maxAmount if both are provided. 
         * @param {number} [maxAmount] Maximum net payout amount in cents (inclusive). Must be greater than or equal to minAmount if both are provided. 
         * @param {ExportPayoutsSortByEnum} [sortBy] Field to sort by
         * @param {ExportPayoutsSortDirectionEnum} [sortDirection] Sort direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPayouts(partnerId: string, format: ExportPayoutsFormatEnum, startDate: string, endDate: string, merchantIds?: string, merchantName?: string, minAmount?: number, maxAmount?: number, sortBy?: ExportPayoutsSortByEnum, sortDirection?: ExportPayoutsSortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportPayouts(partnerId, format, startDate, endDate, merchantIds, merchantName, minAmount, maxAmount, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a full financial breakdown for a specific merchant\'s payout on a given settlement date, including gross revenue, refunds, chargebacks, fee breakdown, and individual refund/chargeback transactions.  **Net Payout Formula:** `grossRevenue - fullRefunds - partialRefunds - serviceFees - platformFees - chargebackFees - chargebacks` 
         * @summary Get detailed payout breakdown for a merchant on a specific date
         * @param {string} partnerId Partner identifier
         * @param {string} merchantId Merchant identifier
         * @param {string} activityDate Settlement activity date (ISO 8601 YYYY-MM-DD)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutDetail(partnerId: string, merchantId: string, activityDate: string, options?: RawAxiosRequestConfig): AxiosPromise<PayoutDetailResponse> {
            return localVarFp.getPayoutDetail(partnerId, merchantId, activityDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated payout summaries grouped by merchant and settlement date. Each row represents one merchant\'s settled activity for one day.  **Date Range:** Maximum 90 days. End date cannot be in the future. 
         * @summary List payout summaries by merchant and settlement date
         * @param {string} partnerId Partner identifier
         * @param {string} startDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {string} endDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {string} [merchantIds] Comma-separated merchant IDs to filter by
         * @param {string} [merchantName] Partial match on merchant name (case-insensitive, minimum 2 characters)
         * @param {ListPayoutsSortByEnum} [sortBy] Field to sort by
         * @param {ListPayoutsSortDirectionEnum} [sortDirection] Sort direction
         * @param {number} [minAmount] Minimum net payout amount in cents (inclusive). Must be less than or equal to maxAmount if both are provided. 
         * @param {number} [maxAmount] Maximum net payout amount in cents (inclusive). Must be greater than or equal to minAmount if both are provided. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPayouts(partnerId: string, startDate: string, endDate: string, page?: number, size?: number, merchantIds?: string, merchantName?: string, sortBy?: ListPayoutsSortByEnum, sortDirection?: ListPayoutsSortDirectionEnum, minAmount?: number, maxAmount?: number, options?: RawAxiosRequestConfig): AxiosPromise<ListPayoutsResponse> {
            return localVarFp.listPayouts(partnerId, startDate, endDate, page, size, merchantIds, merchantName, sortBy, sortDirection, minAmount, maxAmount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PayoutReportingApi - object-oriented interface
 * @export
 * @class PayoutReportingApi
 * @extends {BaseAPI}
 */
export class PayoutReportingApi extends BaseAPI {
    /**
     * Exports a single merchant\'s payout detail for a specific settlement date as a PDF document.  **File Format:** - Filename format: `payout_detail_{merchantId}_{activityDate}.pdf` - Example: `payout_detail_01HQWX_2026-02-24.pdf` 
     * @summary Export payout detail as PDF
     * @param {string} partnerId Partner identifier
     * @param {string} merchantId Merchant identifier
     * @param {string} activityDate Settlement activity date (ISO 8601 YYYY-MM-DD)
     * @param {ExportPayoutDetailFormatEnum} format Export format: - pdf: PDF document (application/pdf) 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutReportingApi
     */
    public exportPayoutDetail(partnerId: string, merchantId: string, activityDate: string, format: ExportPayoutDetailFormatEnum, options?: RawAxiosRequestConfig) {
        return PayoutReportingApiFp(this.configuration).exportPayoutDetail(partnerId, merchantId, activityDate, format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exports payout summary data in the specified format (CSV or XLSX). Uses the same filtering as the payout list endpoint.  **Export Limits:** - Maximum 10,000 rows per export request  **File Format:** - Filename format: `payouts_{startDate}_to_{endDate}.{format}` - Example: `payouts_2026-02-01_to_2026-02-28.csv` 
     * @summary Export payout summaries as CSV or Excel
     * @param {string} partnerId Partner identifier
     * @param {ExportPayoutsFormatEnum} format Export format: - csv: Comma-separated values (text/csv) - xlsx: Excel spreadsheet (application/vnd.openxmlformats-officedocument.spreadsheetml.sheet) 
     * @param {string} startDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} endDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} [merchantIds] Comma-separated merchant IDs to filter by
     * @param {string} [merchantName] Partial match on merchant name (case-insensitive, minimum 2 characters)
     * @param {number} [minAmount] Minimum net payout amount in cents (inclusive). Must be less than or equal to maxAmount if both are provided. 
     * @param {number} [maxAmount] Maximum net payout amount in cents (inclusive). Must be greater than or equal to minAmount if both are provided. 
     * @param {ExportPayoutsSortByEnum} [sortBy] Field to sort by
     * @param {ExportPayoutsSortDirectionEnum} [sortDirection] Sort direction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutReportingApi
     */
    public exportPayouts(partnerId: string, format: ExportPayoutsFormatEnum, startDate: string, endDate: string, merchantIds?: string, merchantName?: string, minAmount?: number, maxAmount?: number, sortBy?: ExportPayoutsSortByEnum, sortDirection?: ExportPayoutsSortDirectionEnum, options?: RawAxiosRequestConfig) {
        return PayoutReportingApiFp(this.configuration).exportPayouts(partnerId, format, startDate, endDate, merchantIds, merchantName, minAmount, maxAmount, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a full financial breakdown for a specific merchant\'s payout on a given settlement date, including gross revenue, refunds, chargebacks, fee breakdown, and individual refund/chargeback transactions.  **Net Payout Formula:** `grossRevenue - fullRefunds - partialRefunds - serviceFees - platformFees - chargebackFees - chargebacks` 
     * @summary Get detailed payout breakdown for a merchant on a specific date
     * @param {string} partnerId Partner identifier
     * @param {string} merchantId Merchant identifier
     * @param {string} activityDate Settlement activity date (ISO 8601 YYYY-MM-DD)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutReportingApi
     */
    public getPayoutDetail(partnerId: string, merchantId: string, activityDate: string, options?: RawAxiosRequestConfig) {
        return PayoutReportingApiFp(this.configuration).getPayoutDetail(partnerId, merchantId, activityDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated payout summaries grouped by merchant and settlement date. Each row represents one merchant\'s settled activity for one day.  **Date Range:** Maximum 90 days. End date cannot be in the future. 
     * @summary List payout summaries by merchant and settlement date
     * @param {string} partnerId Partner identifier
     * @param {string} startDate Start of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {string} endDate End of date range (ISO 8601 YYYY-MM-DD, inclusive)
     * @param {number} [page] The zero-based index of the page of results to return.
     * @param {number} [size] The maximum number of results to return in a page.
     * @param {string} [merchantIds] Comma-separated merchant IDs to filter by
     * @param {string} [merchantName] Partial match on merchant name (case-insensitive, minimum 2 characters)
     * @param {ListPayoutsSortByEnum} [sortBy] Field to sort by
     * @param {ListPayoutsSortDirectionEnum} [sortDirection] Sort direction
     * @param {number} [minAmount] Minimum net payout amount in cents (inclusive). Must be less than or equal to maxAmount if both are provided. 
     * @param {number} [maxAmount] Maximum net payout amount in cents (inclusive). Must be greater than or equal to minAmount if both are provided. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutReportingApi
     */
    public listPayouts(partnerId: string, startDate: string, endDate: string, page?: number, size?: number, merchantIds?: string, merchantName?: string, sortBy?: ListPayoutsSortByEnum, sortDirection?: ListPayoutsSortDirectionEnum, minAmount?: number, maxAmount?: number, options?: RawAxiosRequestConfig) {
        return PayoutReportingApiFp(this.configuration).listPayouts(partnerId, startDate, endDate, page, size, merchantIds, merchantName, sortBy, sortDirection, minAmount, maxAmount, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ExportPayoutDetailFormatEnum = {
    Pdf: 'pdf'
} as const;
export type ExportPayoutDetailFormatEnum = typeof ExportPayoutDetailFormatEnum[keyof typeof ExportPayoutDetailFormatEnum];
/**
 * @export
 */
export const ExportPayoutsFormatEnum = {
    Csv: 'csv',
    Xlsx: 'xlsx'
} as const;
export type ExportPayoutsFormatEnum = typeof ExportPayoutsFormatEnum[keyof typeof ExportPayoutsFormatEnum];
/**
 * @export
 */
export const ExportPayoutsSortByEnum = {
    MerchantName: 'merchantName',
    ActivityDate: 'activityDate',
    NetPayoutCents: 'netPayoutCents',
    TotalSales: 'totalSales'
} as const;
export type ExportPayoutsSortByEnum = typeof ExportPayoutsSortByEnum[keyof typeof ExportPayoutsSortByEnum];
/**
 * @export
 */
export const ExportPayoutsSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ExportPayoutsSortDirectionEnum = typeof ExportPayoutsSortDirectionEnum[keyof typeof ExportPayoutsSortDirectionEnum];
/**
 * @export
 */
export const ListPayoutsSortByEnum = {
    MerchantName: 'merchantName',
    ActivityDate: 'activityDate',
    NetPayoutCents: 'netPayoutCents',
    TotalSales: 'totalSales'
} as const;
export type ListPayoutsSortByEnum = typeof ListPayoutsSortByEnum[keyof typeof ListPayoutsSortByEnum];
/**
 * @export
 */
export const ListPayoutsSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListPayoutsSortDirectionEnum = typeof ListPayoutsSortDirectionEnum[keyof typeof ListPayoutsSortDirectionEnum];
